// extracted by mini-css-extract-plugin
export default {"wrapper":"uz3pTi7","rolesDropdown":"_G7jBvx","entityDropdown":"ThkW80j","removeIcon":"Fvw2eAI","disabled":"yT8jiJ4"};